import React, { Component } from 'react'
import { GoogleMap, StreetViewPanorama, Marker } from '@react-google-maps/api'

import { holeHelper } from '../../helpers'

const initialState = {
  show: false
}

class StreetView extends Component {
  constructor () {
    super()
    this.state = initialState
    this.timer = null
  }

  componentDidMount () {
    this.timer = setTimeout(() => {
      this.setState({ show: true })
    }, 100)
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  render () {
    const hole = this.props.hole
    return (
      <div>
        <GoogleMap
          mapContainerStyle={{
            height: '400px',
            width: '100%'
          }}
          zoom={7}
          center={{
            lat: hole.latitude,
            lng: hole.longitude
          }}
        >
          {
            this.state.show && (
              <StreetViewPanorama
                position={{
                  lat: hole.latitude,
                  lng: hole.longitude
                }}
                visible={true}
              />
            )
          }
          <Marker
            position={{ lat: hole.latitude, lng: hole.longitude }}
            icon={holeHelper.holeMarker(hole)}
          />
        </GoogleMap>
      </div>
    )
  }
}

export default StreetView
